var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m8.782 6.66 1.36-1.41-4.825-5-4.825 5 1.36 1.41 2.5-2.58v9.67h1.93V4.08l2.5 2.58Z",
  clipRule: "evenodd"
})));
export { SvgArrowUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljc4MjA0IDYuNjZMMTAuMTQyOCA1LjI1TDUuMzE3MzggMC4yNUwwLjQ5MTk0MyA1LjI1TDEuODUyNzIgNi42Nkw0LjM1MjI5IDQuMDhWMTMuNzVINi4yODI0N0w2LjI4MjQ3IDQuMDhMOC43ODIwNCA2LjY2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";